import { GlobalDispatch } from 'context';
import { CustomErrorCode } from 'domain/error-code';
import { ModalDialogueProps } from 'shared/components/ModalDialogue/ModalDialogue';
import { RequestError } from 'shared/domain/http/request-error';
import { ErrorDelivery, ErrorDeliveryTarget } from 'shared/utils/error-delivery';
import { appInterceptor } from 'shared/utils/interceptors';
import { combineInterceptors, createInterceptor, fetchWithInterceptor } from 'shared/utils/interceptors/interceptor';
import { renderErrorMessage } from 'shared/utils/render-error-message';
import { GlobalAction } from 'store/global-actions';

export const globalInterceptor = createInterceptor(async (response, intercept, next) => {
  if (response.ok) return next();

  const error = (await response.json()) as RequestError<any>;

  switch (error.code) {
    case CustomErrorCode.InputValidation:
      intercept(
        ErrorDelivery.from<ModalDialogueProps>(
          {
            isVisible: true,
            title: 'Error',
            primaryButtonLabel: 'Aceptar',
            primaryAction: (dispatch: GlobalDispatch) => {
              dispatch({ type: GlobalAction.SetModalAlert, payload: null });
            },
            children: renderErrorMessage(error.message),
          },
          ErrorDeliveryTarget.ModalAlert,
        ),
      );
      break;
    default:
      next();
  }
});

export const fetch = fetchWithInterceptor(combineInterceptors([appInterceptor, globalInterceptor]));
